import { render } from "./Booking.vue?vue&type=template&id=2b89f329&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"

import "./Booking.vue?vue&type=style&index=0&id=2b89f329&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b89f329"]])

export default __exports__